/**
 * Settings Notifications - AJAX Checkbox Handler
 * Handles automatic saving of notification settings when checkboxes are changed
 *
 * @author InterPals Development Team
 * @version 1.0.0
 */

(function() {
    'use strict';

    if (!window.SettingsHelpers || !window.SettingsHelpers.isSection('notifications')) {
        return;
    }

    // Use shared helpers
    var helpers = window.SettingsHelpers;

    var REQUEST_TIMEOUT = 10000; // 10 seconds

    var CSS_CLASSES = {
        AJAX_CHECKBOX: 'ajax-checkbox',
        AJAX_NOTIFICATION_SWITCH: 'ajax-notification-switch'
    };

    /**
     * Initialize AJAX checkbox handlers
     * Sets up event listeners for all AJAX-enabled checkboxes
     */
    function initAjaxCheckboxes() {
        // Find all checkboxes with ajax-checkbox class (legacy)
        var ajaxCheckboxes = document.querySelectorAll('.' + CSS_CLASSES.AJAX_CHECKBOX);

        ajaxCheckboxes.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {
                handleCheckboxChange(this, this.checked);
            });
        });

        // Find all notification switches (new card design)
        var notificationSwitches = document.querySelectorAll('.' + CSS_CLASSES.AJAX_NOTIFICATION_SWITCH);

        notificationSwitches.forEach(function(switchInput) {
            switchInput.addEventListener('change', function() {
                handleSwitchChange(this, this.checked);
            });
        });
    }

    /**
     * Handle switch change event with AJAX request
     * @param {HTMLInputElement} switchInput - The switch element that was changed
     * @param {boolean} newState - The new state of the switch
     */
    function handleSwitchChange(switchInput, newState) {
        var fieldName = switchInput.getAttribute('data-field');
        var card = switchInput.closest('.notification-row') || switchInput.closest('.notification-card');

        if (!fieldName || !card) {
            return;
        }

        var originalState = !newState;

        helpers.sendFieldUpdate({
            fieldName: fieldName,
            fieldValue: newState ? '1' : '0',
            container: card,
            field: switchInput,
            timeout: REQUEST_TIMEOUT,
            onSuccess: function(data) {
                // Ensure switch state matches the server response
                switchInput.checked = Boolean(parseInt(data.value));
                window.SwitchComponent?.refresh(switchInput);
            },
            onError: function() {
                // Revert switch state on error
                switchInput.checked = originalState;
                window.SwitchComponent?.refresh(switchInput);
            }
        });
    }

    /**
     * Handle checkbox change event with AJAX request
     * @param {HTMLInputElement} checkbox - The checkbox element that was changed
     * @param {boolean} newState - The new state of the checkbox
     */
    function handleCheckboxChange(checkbox, newState) {
        var ajaxUrl = checkbox.getAttribute('data-ajax-url');
        var fieldName = checkbox.getAttribute('data-field');
        var spinnerElement = document.getElementById(fieldName + '-spinner');
        var label = checkbox.closest('label');

        if (!ajaxUrl || !fieldName) {
            return;
        }

        var originalState = !newState;

        helpers.sendFieldUpdate({
            fieldName: fieldName,
            fieldValue: newState ? '1' : '0',
            container: label,
            field: checkbox,
            spinner: spinnerElement,
            url: ajaxUrl,
            timeout: REQUEST_TIMEOUT,
            onSuccess: function(data) {
                // Ensure checkbox state matches the server response
                checkbox.checked = Boolean(parseInt(data.value));
            },
            onError: function() {
                // Revert checkbox state on error
                checkbox.checked = originalState;
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAjaxCheckboxes);
    } else {
        initAjaxCheckboxes();
    }

})();
